// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"b4b0e098","293":"53fed951","423":"6dd8466d","564":"86b5a179","760":"40221937","882":"c39ccc51","893":"d592b599","910":"8d7a099c"}[chunkId] + ".chunk.js";
};